{
  "Earlier": "較早",
  "newNotification": "{newCount} 則新通知",
  "newNotifications": "{newCount} 則新通知",
  "noNotifications": "您會收到產品、您和其他使用者的協作情況，以及其他相關更新的重要資訊",
  "noNotificationsTitle": "通知會顯示於此處"
}
